import React from "react";

function ClockIcon({ viewBox = "0 0 18 18", className = "" }) {
  return (
    <svg data-testid="clock-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox={viewBox} className={className}>
      <g>
        <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 14.625a5.625 5.625 0 100-11.25 5.625 5.625 0 000 11.25z"></path>
          <path d="M9 5.25V9h3.75"></path>
        </g>
      </g>
    </svg>
  );
}

export default ClockIcon;
